import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/data-loaders';
import type { AclUsersFilters } from '#server/models';

export const useAreaAclUsers = (areaSlug: string, page: number, pageSize: number, filters?: AclUsersFilters) =>
  trpc.getAreaAclUsers.useQuery(
    { areaSlug, page, pageSize, ...filters },
    { retry: false, placeholderData: keepPreviousData }
  );
